import { Activity, Sparkles, AlertTriangle, Gauge } from "lucide-react";
import { cn } from "@/lib/utils";
import type { ConfidenceRating } from "@/lib/viralIntel/confidenceEngine";
import {
  getConfidenceVisual,
  type ConfidenceTier,
} from "@/lib/viralIntel/confidenceDisplay";

/**
 * ConfidenceBadge — premium, screenshot-friendly UI for the Confidence
 * Engine. Pure presentation. Picks tier-appropriate icon and styling.
 */
export function ConfidenceBadge({
  rating,
  tier = "compact",
  className,
}: {
  rating: ConfidenceRating;
  tier?: ConfidenceTier;
  className?: string;
}) {
  const v = getConfidenceVisual(rating, tier);
  const Icon =
    rating.level === "volatile"
      ? AlertTriangle
      : rating.level === "strong_trend"
        ? Sparkles
        : rating.level === "limited_sample"
          ? Gauge
          : Activity;
  const iconSize =
    tier === "cinematic" ? "h-4 w-4" : tier === "minimal" ? "h-2.5 w-2.5" : "h-3 w-3";
  return (
    <span className={cn(v.className, className)}>
      <Icon className={iconSize} />
      <span>{v.caption}</span>
    </span>
  );
}